export default __webpack_public_path__ + "static/media/food4_thumb.16acbbaf.jpg";